function getState(activationcardState) {
    return {
        type: "ACTIVATIONCARD_STATE",
        activationcardState
    }
}

export const getactivationcardAction = (state) =>dispatch=>{

    let activationcardState = state
    dispatch(getState(activationcardState))
}


// WEBPACK FOOTER //
// ./src/actions/getcardactivation.jsx